import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "className", "auto", "size", "color"],
  _excluded2 = ["name", "className", "small", "medium", "large", "color", "light", "size", "auto"],
  _excluded3 = ["material"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import isString from 'lodash/isString';
var FaIcon = function FaIcon(_ref) {
  var name = _ref.name,
    className = _ref.className,
    auto = _ref.auto,
    size = _ref.size,
    color = _ref.color,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("i", _extends({}, rest, {
    className: cx("Icon fa fa-".concat(name), className),
    style: _objectSpread(_objectSpread({}, !auto && {
      fontSize: size,
      width: size,
      height: size,
      lineHeight: isString(size) ? size : size + 'px'
    }), {}, {
      color: color
    }),
    "data-test": "".concat(name, "-fa-icon")
  }));
};
FaIcon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
  color: PropTypes.string,
  auto: PropTypes.bool
};
FaIcon.defaultProps = {
  size: 21
};
var RE_MATERIAL_NAME = /\s/g;
var MaterialIcon = function MaterialIcon(_ref2) {
  var name = _ref2.name,
    className = _ref2.className,
    small = _ref2.small,
    medium = _ref2.medium,
    large = _ref2.large,
    color = _ref2.color,
    light = _ref2.light,
    size = _ref2.size,
    auto = _ref2.auto,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement("i", _extends({}, rest, {
    className: cx('material-icons', small && 'md-18', medium && 'md-36', large && 'md-48', light && 'md-light', className),
    style: {
      color: color,
      fontSize: auto ? 'inherit' : size
    }
  }), name.replace(RE_MATERIAL_NAME, '_'));
};
MaterialIcon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  small: PropTypes.bool,
  medium: PropTypes.bool,
  large: PropTypes.bool,
  light: PropTypes.bool,
  auto: PropTypes.bool,
  color: PropTypes.string,
  size: PropTypes.number
};

/**
 * Icon component, using Font Awesome or Material Icons, depending on the `material` prop.
 */
export default function Icon(_ref3) {
  var material = _ref3.material,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return material ? /*#__PURE__*/React.createElement(MaterialIcon, props) : /*#__PURE__*/React.createElement(FaIcon, props);
}
Icon.propTypes = {
  material: PropTypes.bool
};
//# sourceMappingURL=index.js.map
